import { Outlet } from "react-router-dom";
import NavDropdown from "../../components/nav/NavDropdown";
import Sidebar from "../../components/pages/admin/id/Sidebar";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../../components/ErrorFallback";
import { useContext } from "react";
import { UserQueryContext } from "../../context/UserContext";
import AccessDenied from "../../components/AccessDenied";

export default function AdminLayout() {
  const { user, hasPermission } = useContext(UserQueryContext);
  if (!hasPermission(user, "AdminRead")) return <AccessDenied />;
  return (
    <>
      <meta name="theme-color" content="#0056ba" />
      <div className="l-main">
        <header className="navbar">
          <NavDropdown />
        </header>
        <div className="l-main__content">
          <div className="l-main-row">
            <Sidebar />
            <main className="col overflow-hidden">
              <div className="c-tabs bg-white">
                <div className="tab__content">
                  <ErrorBoundary FallbackComponent={ErrorFallback}>
                    <Outlet />
                  </ErrorBoundary>
                </div>
              </div>
            </main>
          </div>
        </div>
      </div>
    </>
  );
}
